/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_P1Inputs */

const en_about_section3_p1 = /** @type {(inputs: About_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON offers a comprehensive suite of JSON tools:`)
};

const ko_about_section3_p1 = /** @type {(inputs: About_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 포괄적인 JSON 도구 모음을 제공합니다:`)
};

const ja_about_section3_p1 = /** @type {(inputs: About_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは包括的なJSONツールスイートを提供します：`)
};

/**
* | output |
* | --- |
* | "PureJSON offers a comprehensive suite of JSON tools:" |
*
* @param {About_Section3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_p1 = /** @type {((inputs?: About_Section3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_p1(inputs)
	if (locale === "ko") return ko_about_section3_p1(inputs)
	return ja_about_section3_p1(inputs)
});